import { TableConfig } from 'src/app/shared/components/generic-table';
import { AlertEmail } from 'src/app/services/models/alert-service/alert-email.model';

export type WalletEmailsColumnKeys = keyof AlertEmail | '_status' | '_actions';

export const WALLET_EMAILS_NO_DATA_MESSAGE = $localize`:@@noDataDisplay:No hay datos para mostrar.`;

export const getWalletEmailsTableConfig = (): TableConfig<AlertEmail, WalletEmailsColumnKeys> => ({
  columns: [
    {
      id: 'email',
      title: 'E-mail',
      width: '1fr',
      minWidth: '200px',
    },
    {
      id: 'position',
      title: $localize`:@@positionName:Puesto`,
      width: '220px',
      minWidth: '180px',
    },
    {
      id: '_status',
      title: $localize`:@@activeLabel:Activo`,
      hasCustomContent: true,
      width: '100px',
      textAlign: 'center',
    },
    {
      id: '_actions',
      title: $localize`:@@actions:Acciones`,
      hasCustomContent: true,
      width: '100px',
      textAlign: 'center',
    },
  ],
  trackByProp: ['email'],
  rowIdFn: (row: AlertEmail) => String(row.id)
});

export const walletEmailsTableConfig = getWalletEmailsTableConfig();
